/** Drawn as inline SVG so there is no image file to go missing, at any size. */
export function Masthead({ width = 260 }: { width?: number }) {
    return (
        <svg width={width} viewBox="0 0 260 76" role="img" aria-label="Elbow Room" style={{ display: 'block' }}>
            {/* a plan view: an L-shaped room with a dimension line under it */}
            <g stroke="#1d3b36" strokeWidth="2.4" fill="none" strokeLinejoin="round">
                <path d="M8 12 H52 V34 H74 V60 H8 Z" fill="#f3efe6" />
            </g>
            <g stroke="#c2703a" strokeWidth="1.6">
                <path d="M8 68 H74" />
                <path d="M8 64.5 V71.5 M74 64.5 V71.5" />
            </g>
            <rect x="30" y="40" width="18" height="14" fill="#1d3b36" opacity="0.18" />
            <text x="92" y="36" fontFamily="ui-serif, Georgia, 'Times New Roman', serif"
                fontSize="30" fontWeight="600" fill="#1d3b36" letterSpacing="0.5">Elbow</text>
            <text x="92" y="64" fontFamily="ui-serif, Georgia, 'Times New Roman', serif"
                fontSize="30" fontWeight="600" fill="#c2703a" letterSpacing="0.5">Room</text>
        </svg>
    );
}
